import React, { useEffect, useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import "../styles.css";
import Loading from "./loading";

const SearchResults = (props) => {
  const API = props.api;
  const query = props.value.query;
  const [fetched, setFetched] = useState({});
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    async function getPopularVideos() {
      const search = await fetch(
        `https://www.googleapis.com/youtube/v3/search?part=snippet&maxResults=20&q=${query}&regionCode=IN&type=video&key=${API}`
      );
      const datasearch = await search.json();
      setFetched({ popular: datasearch });
      setLoading(false);
    }
    getPopularVideos();
  }, []);
  return (
    <>
      {loading ? (
        <Loading/>
      ) : (
        <>
          <Router>
           <section id="section1">
            <div className="search">
              {fetched.popular.items.map((val, index) => (
                <a href={`/${val.id.videoId}`} key={index}>
                  <img
                    id="pop_img"
                    key={index}
                    src={val.snippet.thumbnails.high.url}
                    alt=""
                  />
                </a>
              ))}
            </div>
            </section>
          </Router>
        </>
      )}
    </>
  );
};

export default SearchResults;
